import { Box, useTheme } from '@mui/material';
import { Ref } from 'react';
import { SafeArea } from './SafeArea';

interface Props {
  header?: React.ReactNode;
  paperBackground?: boolean;
  backgroundColor?: string;

  /**
   * Changes the top color on the ios overload scroll.
   */
  iosOverloadScrollBackground?: string;
  padded?: boolean;
  paddedHeader?: boolean;
  paddedBody?: boolean;
  scrollRef?: Ref<HTMLDivElement>;
}

export const MobileLayout: React.FC<React.PropsWithChildren<Props>> = ({
  header,
  paperBackground: paper = false,
  backgroundColor,
  padded,
  paddedHeader,
  paddedBody,
  iosOverloadScrollBackground,
  scrollRef,
  children,
}) => {
  const theme = useTheme();
  const defaultBackground = paper ? theme.palette.background.paper : theme.palette.background.default;
  const background = backgroundColor || defaultBackground;

  return (
    <SafeArea
      edges={padded ? ['top'] : []}
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        padding: padded ? 1 : 0,
        background,
        [theme.breakpoints.up('sm')]: {
          width: '450px',
          marginX: 'auto',
        },
        position: 'relative',
      }}
    >
      {header && (
        <SafeArea
          edges={paddedHeader ? ['top'] : []}
          sx={{
            paddingX: paddedHeader ? 1 : 0,
            display: 'flex',
            flexDirection: 'column',
            flexShrink: 0,
          }}
        >
          {header}
        </SafeArea>
      )}
      <SafeArea
        ref={scrollRef}
        edges={['bottom']}
        extra={paddedBody ? 20 : 0}
        sx={{
          padding: paddedBody ? '0px 20px 20px 20px' : 0,
          flexGrow: 1,
          // Lets this flex item shrink below its intrinsic content height when
          // the keyboard shrinks the WebView (otherwise content overflows).
          minHeight: 0,
          overflow: 'auto',
          ...(iosOverloadScrollBackground
            ? {
                background: `linear-gradient(0deg, ${background} 49%, ${iosOverloadScrollBackground} 51%)`,
              }
            : {
                background,
              }),
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {iosOverloadScrollBackground && <Box sx={{ flexGrow: 1, background }}>{children}</Box>}
        {!iosOverloadScrollBackground && children}
      </SafeArea>
    </SafeArea>
  );
};
